import React from 'react';
import mainClasses from '../../../pages/Main/Main.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonMainAboutSlider() {
  return (
    <div className={mainClasses.aboutSliderBox}>
      <div className={mainClasses.aboutSlider}>
        <Skeleton borderRadius='0px' width='100%' height='100%' isLight />
      </div>
    </div>
  );
}
